// Public client-side credentials for the Google Identity Services
// (GSI) + Gmail API integrations.
//
// SAFE IN BUNDLE: both the client ID and the API key are
// HTTP-referrer-restricted at the Google Cloud Console layer
// (Authorized JavaScript origins on the OAuth client; HTTP
// referrer restriction on the API key). Committing them to the JS
// bundle is the documented Google pattern. The same pair is used
// by the legacy showcase frontend (`inrange-agents/frontend/app.jsx`)
// without change; the v2 CloudFront origin
// (`https://d3gwdaa037dw8e.cloudfront.net`) must be present in the
// allowlist for OAuth to land - if you see a `403 origin not
// allowed` from GSI on a fresh deploy, add the origin via the
// Google Cloud Console.
//
// Scope is `gmail.readonly` only - the narrowest read scope that
// lets us list / read threads. No outbound capability is
// requested or available; the agent cannot send, label, or delete
// from the operator's Gmail.
export const GOOGLE_CLIENT_ID =
  "817990859752-51qepiah2o59o94br0chrrbcej4s1ah1.apps.googleusercontent.com";
export const GOOGLE_API_KEY = "AIzaSyAEek1lMvWb0WL5q0cLUfxuAoQxley4Cio";
export const GOOGLE_GMAIL_SCOPE = "https://www.googleapis.com/auth/gmail.readonly";
// `drive.readonly` rather than the narrower `drive.file` because
// `drive.files.list?q='FOLDER_ID' in parents` needs read access
// to the folder's children, which `drive.file` does NOT grant for
// items the user hasn't explicitly opened via the picker. The
// picker UI still constrains what the operator actually shares -
// we only fetch the folder they pick - so the broader scope is
// only used to walk INSIDE that scope, never to enumerate
// arbitrary Drive content.
export const GOOGLE_DRIVE_SCOPE = "https://www.googleapis.com/auth/drive.readonly";

// Sanity guard - replace these placeholder strings with real
// values from the Google Cloud Console if/when we rotate. The
// `.startsWith("PLACEHOLDER")` check matches the legacy
// `GOOGLE_PICKER_READY` pattern; the panel disables itself when
// false rather than blowing up at GSI init time.
export const GOOGLE_OAUTH_READY =
  !GOOGLE_CLIENT_ID.startsWith("PLACEHOLDER") &&
  !GOOGLE_API_KEY.startsWith("PLACEHOLDER");
